import { DictionaryContents } from "src/utils/pdfParse";
import { DictionaryLevel } from "../pages/PDFMappingTool";
import { exhaustiveGuard } from "src/utils/exhaustiveGuard";

export default function deleteMapping(
  dictionary: DictionaryContents,
  chain: DictionaryLevel[],
  remapFromValue: string
) {
  if (chain.length > 1) {
    switch (dictionary.enumerable) {
      case "byOffset":
      case false:
        {
          const newChain = chain.slice(1);
          if (dictionary.subforms === null) return;
          deleteMapping(
            dictionary.subforms[chain[1].formId],
            newChain,
            remapFromValue
          );
        }
        break;
      case "specifiedLocation":
        {
          const newChain = chain.slice(1);
          const nextEnumeration = chain[0].enumeration;
          if (nextEnumeration === false) return;
          const newDictionary =
            dictionary.enumerations[nextEnumeration].subforms![chain[1].formId];
          deleteMapping(newDictionary, newChain, remapFromValue);
        }
        break;
      case "groupMember":
        return;
      default:
        exhaustiveGuard(dictionary);
    }
  } else {
    if (!dictionary.remaps) return;
    delete dictionary.remaps[remapFromValue];
  }
}
